export const TableHeader = () => (
  <tr className="border-b bg-gray-100">
    <th className="text-left py-3 px-2 md:px-4 font-medium text-xs">Name</th>
    <th className="text-left py-3 px-2 md:px-4 font-medium text-xs">Status</th>
    <th className="py-3 px-2 md:px-4 font-medium text-xs">About</th>
    <th className="text-left py-3 px-2 md:px-4 font-medium text-xs">Members</th>
    <th className="text-left py-3 px-2 md:px-4 font-medium text-xs">Progress</th>
    <th className="text-left py-3 px-2 md:px-4 font-medium text-xs">Deadline</th>
    <th className="text-left py-3 px-2 md:px-4 font-medium text-xs">Priority</th>
    <th className="w-10"></th>
  </tr>
);
